<template>
<div class="chapter">
<div class="inner_page">
<div class="lines"><img alt="" class="img23" src="Images/line_top.jpg"/></div>
<p class="tp4">THIRD EDITION</p>
<div class="lines"><img alt="" class="img23" src="Images/line_bottom.jpg"/></div>
<p class="tp3" style="font-size:1.1em"><i>An Introduction to</i></p>
<h2 style="font-size:2.2em; margin-top:.1em" title="Title Page">BIBLICAL<br/>
  ETHICS</h2>
<p class="tp3"><i>WALKING IN THE WAY OF WISDOM</i><br/></p>
<p class="body"></p>
<h3 class="sigil_not_in_toc"><span class="small-caps">Robertson McQuilkin<br/>
<em class="i">and</em> Paul Copan</span></h3>
<p class="first"><br/></p>
<p class="firstcenter"><img alt="IVP Academic Imprint" src="Images/IVP_Academic_Quarter.jpg"/></p>
<p class="center"><a href="http://www.IVPress.com/books" target="_blank">www.IVPress.com/academic</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// titlepage.vue?4fda2fbf